
import React from 'react';
import PropTypes from 'prop-types';
import css from './styles/ErrorPagesLayout.module.scss';
import { Container, Row, Col, Image } from 'react-bootstrap';
const currentYear = (new Date).getFullYear();

export default function ErrorPagesLayout(props) {
    return (
        <div>
            <Container className="misc-pages">
                <Image className="site-logo" src="/images/logo.png" alt="EditionGuard Logo" />
                <Row className={css.pageNotFoundContainer}>
                    <Col lg={9} className="d-flex">
                        <div className={css.mainContainer}>
                            { props.children }
                        </div>
                    </Col>
                </Row>
                <div className="copyright-container">
                    <p>© Copyright {currentYear} EditionGuard LLC. All rights reserved.</p>
                </div>
            </Container>
        </div>
    );
}

ErrorPagesLayout.propTypes = {
    children: PropTypes.any
};
    